// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "content-v3xFX";
var _4 = "title-3iQgE";
var _5 = "routes-vGKVW";
var _6 = "segment-20oEt";
var _7 = "iata-1mDjE";
var _8 = "cities-Yk1tQ";
var _9 = "controls-2i1O_";
var _a = "scrollBody-FC-GM";
var _b = "paper-3KUYD";
export { _1 as "__esModule", _2 as "mobile", _3 as "content", _4 as "title", _5 as "routes", _6 as "segment", _7 as "iata", _8 as "cities", _9 as "controls", _a as "scrollBody", _b as "paper" }
export default { "__esModule": _1, "mobile": _2, "content": _3, "title": _4, "routes": _5, "segment": _6, "iata": _7, "cities": _8, "controls": _9, "scrollBody": _a, "paper": _b }
